/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ComponentType, FC } from 'react';

export type DynamicImportType = () => Promise<{
  default: ComponentType | FC<any>;
}>;

interface IBaseRouteConfig {
  path: string;
  children?: (IRouterConfig | ILazyRouterConfig)[];
}

/* 默认路由配置 */
export interface IRouterConfig extends IBaseRouteConfig {
  component: ComponentType;
  lazy: false;
}

/* 懒路由配置 */
export interface ILazyRouterConfig extends IBaseRouteConfig {
  component: DynamicImportType;
  lazy: true; // 是否懒加载。 默认为true
}

/* 重定向路由配置 */
export interface IRedirectRouterConfig {
  path: string;
  redirect: string;
}

export type IRouteType =
  | IRouterConfig
  | ILazyRouterConfig
  | IRedirectRouterConfig;

/**
 * 判断是否为重定向配置
 */
export function isRedirect(
  config: IRouteType,
): config is IRedirectRouterConfig {
  return !!(config as IRedirectRouterConfig).redirect;
}

/**
 * 判断是否为懒路由
 */
export function isLazyComponent(
  config: IRouteType,
): config is ILazyRouterConfig {
  return (config as ILazyRouterConfig).lazy;
}

const routerConfig: IRouteType[] = [
  {
    path: '/index',
    component: () => import('pages/index'),
    lazy: true,
  },
  {
    path: '/about',
    component: () => import('pages/about'),
    lazy: true,
  },
];
export default routerConfig;
